var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_140755)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38572 0.735509C7.57275 0.628561 7.78449 0.572281 8 0.572281C8.21551 0.572281 8.42725 0.628561 8.61428 0.735509L14.1141 3.82916C14.3062 3.93825 14.4661 4.09605 14.5778 4.28665C14.6894 4.47725 14.7488 4.69392 14.75 4.91481L14.75 4.91884L14.75 11.0813H14L14.75 11.0854C14.7488 11.3063 14.6894 11.5229 14.5778 11.7135C14.4661 11.9041 14.3062 12.0619 14.1141 12.171L14.1114 12.1725L8.61426 15.2647C8.42723 15.3716 8.2155 15.4279 8 15.4279C7.7845 15.4279 7.57277 15.3716 7.38574 15.2647L1.88855 12.1725L1.88589 12.171C1.69381 12.0619 1.53389 11.9041 1.42225 11.7135C1.31061 11.5229 1.2512 11.3063 1.25001 11.0854L1.25 11.0813V4.91481C1.25119 4.69393 1.31061 4.47725 1.42225 4.28665C1.53389 4.09605 1.69381 3.93825 1.88589 3.82917L1.88855 3.82766L7.38572 0.735509ZM13.25 10.9361V5.06412L8 2.11099L2.75 5.06412V10.9361L8 13.8892L13.25 10.9361Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34328 2.57537C4.54333 2.21267 4.99953 2.08081 5.36224 2.28086L11.4247 5.62461C11.664 5.75655 11.8125 6.00814 11.8125 6.28134V9.53134C11.8125 9.94556 11.4767 10.2813 11.0625 10.2813C10.6483 10.2813 10.3125 9.94556 10.3125 9.53134V6.7242L4.6378 3.59433C4.27509 3.39428 4.14324 2.93808 4.34328 2.57537Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41364 4.29744C1.61531 3.93563 2.0721 3.80582 2.4339 4.00749L8.05275 7.13951L13.5608 4.01048C13.9209 3.80588 14.3788 3.93198 14.5834 4.29214C14.788 4.65229 14.6619 5.11012 14.3017 5.31472L8.4267 8.65222C8.19885 8.78165 7.91997 8.78278 7.69108 8.6552L1.70358 5.3177C1.34178 5.11602 1.21197 4.65924 1.41364 4.29744Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06257 7.25012C8.47677 7.25361 8.80971 7.59221 8.80622 8.00641L8.74997 14.6814C8.74648 15.0956 8.40788 15.4286 7.99368 15.4251C7.57948 15.4216 7.24654 15.083 7.25003 14.6688L7.30628 7.99377C7.30977 7.57957 7.64837 7.24663 8.06257 7.25012Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_140755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.a7527ca8.svg";
export { ForwardRef as ReactComponent };